'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../components/Layout/LoginLayout.scss.js');
var Header = require('../components/Header.js');
require('../components/PopUp.scss.js');
require('../../../styles/index.scss.js');
require('../../../../node_modules/react-responsive-modal/styles.css.js');
var Button = require('../../Button/Button.js');
require('../../../../node_modules/classnames/index.js');
require('../../ButtonGroup/ButtonGroup.scss.js');
require('../../Badge/Badge.scss.js');
require('../../Label/Label.scss.js');
require('../../Checkbox/Checkbox.scss.js');
require('../../Icon/Icon.scss.js');
require('../../Button/helper.scss.js');
require('../../Switch/Switch.scss.js');
require('../../Radio/Radio.scss.js');
var Input = require('../../Input/Input.js');
require('../../Loader/Loader.scss.js');
require('../../Footer/Footer.scss.js');
require('../../Navbar/Navbar.js');
require('../../Navbar/MobileNavigation/styles.scss.js');
require('../../../../node_modules/pure-react-carousel/dist/index.es.js');
require('../../Carousel/Carousel.scss.js');
require('../../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');
require('../../Pagination/Pagination.scss.js');
require('../../Modal/Modal.scss.js');
require('../../DropDown/DropDown.scss.js');
require('../../Accordion/Accordion.scss.js');
require('../../Stepper/Stepper.scss.js');
require('../../Tabs/Tabs.scss.js');
require('../../BottomNavigation/FooterNavigation/Tools/Tools.scss.js');
require('../../BottomNavigation/FooterNavigation/Insurance/Insurance.scss.js');
require('../../BottomNavigation/FooterNavigation/Account/Account.scss.js');
require('../../BottomNavigation/FooterNavigation/Explore/Explore.scss.js');
require('../../BottomNavigation/FooterNavigation/FooterNavigation.scss.js');
require('../../../utils/hooks/canUseWebp.js');
require('../../BottomNavigation/BottomNavigation.scss.js');
require('../../ViewMore/ViewMore.scss.js');
require('../../Login/Login.js');
require('../index.js');
require('../../Swiper/index.js');
require('../../Alert/Alert.scss.js');
require('../../Loader/LifepalLoader.js');
require('../../SEOAccordion/SEOAccordion.scss.js');
require('../../Skeleton/index.js');
require('../../LifepalProvider/LifepalProvider.js');
require('react-dom');
require('../../../../node_modules/react-responsive-modal/node_modules/classnames/index.js');
require('../../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js');
require('../../ResponsiveModal/style.scss.js');
var googleIcon = require('../../../assets/google-icon.svg.js');
var mail = require('../../../assets/mail.svg.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LoginAccountForm = function (props) {
    var errorMessage = props.errorMessage, isSubmitting = props.isSubmitting, mailIcon = props.mailIcon, googleIcon$1 = props.googleIcon, onNextButtonClick = props.onNextButtonClick, onMailButtonClick = props.onMailButtonClick, onGoogleButtonClick = props.onGoogleButtonClick, onPhoneNumberChange = props.onPhoneNumberChange, title = props.title, back = props.back, backIcon = props.backIcon, onBackButtonClick = props.onBackButtonClick, onRegisterClick = props.onRegisterClick, selectText = props.selectText, className = props.className;
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        title !== false && React__default['default'].createElement(Header.Header, { className: className && className['header'], back: back, onBackButtonClick: onBackButtonClick, backIcon: backIcon, title: title }),
        React__default['default'].createElement("div", { className: "login__forms-accounts " + ((className && className['root']) || className) },
            React__default['default'].createElement(Input.Input, { id: 'input-phoneNumber', name: 'input-phoneNumber', type: 'tel', inputMode: 'tel', placeholder: 'Nomor Telepon', size: 'lg', className: "" + (errorMessage && errorMessage.phoneNumber ? 'login__forms-accounts-inputs__fields__errors' : 'login__forms-accounts-inputs__fields'), onChange: function (e) { if (onPhoneNumberChange) {
                    onPhoneNumberChange(e.target.value);
                } }, disabled: isSubmitting }),
            errorMessage && errorMessage.phoneNumber &&
                React__default['default'].createElement("p", { className: 'login__forms-accounts-inputs__labels__errors' }, errorMessage.phoneNumber),
            React__default['default'].createElement(Button.Button, { id: 'next-to-otp', className: "login__forms-accounts-buttons__primary " + (isSubmitting && 'disabled'), onClick: function () { if (onNextButtonClick) {
                    onNextButtonClick();
                } }, disabled: isSubmitting }, "Selanjutnya"),
            React__default['default'].createElement("div", { className: 'login__forms__divided' },
                React__default['default'].createElement("div", null),
                React__default['default'].createElement("span", null, selectText || 'atau'),
                React__default['default'].createElement("div", null)),
            React__default['default'].createElement(Button.Button, { id: 'login-by-email', className: "login__forms-accounts-buttons__secondary " + (isSubmitting && 'disabled'), onClick: function () { if (onMailButtonClick) {
                    onMailButtonClick();
                } }, disabled: isSubmitting },
                React__default['default'].createElement("div", { className: 'login__forms-accounts-buttons__secondary__icons' }, mailIcon || React__default['default'].createElement("img", { src: mail, alt: 'mail' })),
                "Masuk Menggunakan Email"),
            React__default['default'].createElement(Button.Button, { id: 'login-by-google', className: "login__forms-accounts-buttons__secondary-normal " + (isSubmitting && 'disabled'), onClick: function () { if (onGoogleButtonClick) {
                    onGoogleButtonClick();
                } }, disabled: isSubmitting },
                React__default['default'].createElement("div", { className: 'login__forms-accounts-buttons__secondary__icons' }, googleIcon$1 || React__default['default'].createElement("img", { src: googleIcon, alt: 'google' })),
                "Masuk Menggunakan Gmail"),
            React__default['default'].createElement("div", { className: 'login__forms-accounts-register' },
                React__default['default'].createElement("span", null, "Belum memiliki akun ?"),
                React__default['default'].createElement("span", { className: isSubmitting ? 'disabled' : '', id: 'redirect-to-register', onClick: function () { if (onRegisterClick && !isSubmitting) {
                        onRegisterClick();
                    } } }, " Daftar Sekarang")))));
};

exports.LoginAccountForm = LoginAccountForm;
//# sourceMappingURL=LoginAccountForm.js.map
